<template>
  <div>
    <div class="row">
			<div class="col-md-12 centered">
				<p>
					<!--Занятия проходят во Дворце Учащейся молодежи, расположенном по адресу:
          ул. Малая Конюшенная д.1/3
		  -->
				</p>
				<p>
					<a href="tel:+78129161500" >Телефон: +7 (812) 916-15-00</a>
				</p><br>
			</div>
		</div>
		<div class="row">
			<div class="col-md-12">
				<iframe id="map"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1680.663929863537!2d30.32415810007848!3d59.93782520306914!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4696310e548083db%3A0x2b4270236080aca6!2z0JzQsNC70LDRjyDQmtC-0L3RjtGI0LXQvdC90LDRjyDRg9C7LiwgMSwg0KHQsNC90LrRgi3Qn9C10YLQtdGA0LHRg9GA0LMsIDE5MTE4Ng!5e0!3m2!1sru!2sru!4v1500893477781"
        frameborder="0" style="border:0"  :height="height" allowfullscreen></iframe>
			</div>
		</div>
  </div>
</template>

<script>
export default {
  // name: 'Contacts'
  props: {
    height: {
      type: Number,
      default: null
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #map {
    width: 100%;
  }
  a, a:hover {
    color: black;
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// Contacts.vue?f65ce69a